<app-uni-page [parent]="this" pageTitle="References: Feature Types" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>
<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col w-[30%] h-full">
    <div class="qb-list-actions">
      <button
        [disabled]="!this.user.isProductAdmin"
        pButton
        type="button"
        class="p-button-raised p-button-sm"
        icon="pi pi-plus"
        (click)="featureKindEdit()"
      >
        <span>Add Feature Type</span>
      </button>
    </div>
    <app-ag-grid [gridOptions]="fkGridOptions" [rowData]="featureKinds" class="flex-1 min-h-0"></app-ag-grid>
    <!-- Said on the page, not only in the code. The generic paths accept a new type; only the
         Size and Color special cases are closed to it. -->
    <span class="text-xs italic mt-2" style="color: var(--p-text-muted-color, #6b7280)">
      A new feature type groups features, and a manufacturer can require it. Only a developer can
      make the system treat it like Size or Color.
    </span>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
